/**
 * os-leaflet ; A [Leafletjs](http://leafletjs.com/) TileLayer to display Ordnance Survey
 *       data in your Leaflet map via the OS OpenSpace web map service.
 *
 * https://github.com/rob-murray/os-leaflet
 */

import Proj from '../maps/proj4Mapbox'

const proj4 = require('proj4').default;

const SERVICE_URL = 'https://api.os.uk/maps/raster/v1/zxy'

export default () => {

    new Proj()
    /* This is our namespace for OSMap on Leaflet js */
    L.OSMap = L.OSMap || {};
    L.OSMap.VERSION = '1.0.0';
    L.OSMap.CRS = L.extend(
        new L.Proj.CRS('EPSG:27700', '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +no_defs', {
            resolutions: [896.0, 896.0, 896.0, 896.0, 896.0, 896.0, 896.0, 896.0, 448.0, 224.0, 112.0, 56.0, 28.0, 14.0, 7.0, 3.5, 1.75],
            origin: [-238375.0, 1376256.0]
        })
        , {
            distance: function (a, b) {
                return L.CRS.Earth.distance(a, b);
            }
        }
    );

    L.OSMap.LogoControl = L.Control.extend({
        options: {
            position: 'bottomleft'
        },

        onAdd: function () {
            var container = L.DomUtil.create('div', 'os-logo-control');
            var logoImage = L.DomUtil.create('img', '', container);
            logoImage.title = 'Powered by Ordnance Survey';
            logoImage.src = 'data:image/png;base64,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';

            return container;
        }

    });


    L.OSMap.TileLayer = L.TileLayer.extend({
        initialize: function (apiKey, options) { // (String, String, Object)
            if (!apiKey) {
                throw new Error('OSMap layer requires an API Key parameter to function.');
            }

            // Transform coordinates.
            var transformCoords = function (arr) {
                return proj4('EPSG:27700', 'EPSG:4326', arr).reverse();
            };

            L.TileLayer.prototype.initialize.call(this,
                `${SERVICE_URL}/Leisure_27700/{z}/{x}/{y}.png?key=${apiKey}`, {
                    crs: L.OSMap.CRS,
                    bounds: [
                        transformCoords([-238375.0, 0.0]),
                        transformCoords([900000.0, 1376256.0])
                    ],
                    zoomOffset: -7,
                    maxZoom: 16,
                    attribution: 'Contains OS data &copy; Crown copyright and database rights ' + (new Date()).getFullYear()
                },
                options
            );

            this.logoControl = new L.OSMap.LogoControl()
        },

        onAdd: function (map) {
            const center = map.getCenter()
            const zoom = map.getZoom()
            map.options.crs = L.OSMap.CRS
            
            if (map.options.attributionControl) {
                map.addControl(this.logoControl);
            }

            const resetViewAfterLayerChange = (layer) => {
                map._resetView(center, zoom)
                map.off('baselayerchange', resetViewAfterLayerChange)
            }
            map.on('baselayerchange', resetViewAfterLayerChange)


            L.TileLayer.prototype.onAdd.call(this, map);
        },

        onRemove: function (map) {
            const center = map.getCenter()
            const zoom = map.getZoom()
            map.options.crs = L.CRS.EPSG3857

            if (map.options.attributionControl) {
                map.removeControl(this.logoControl);
            }

            const resetViewAfterLayerChange = (layer) => {
                map._resetView(center, zoom)
                map.off('baselayerchange', resetViewAfterLayerChange)
            }
            map.on('baselayerchange', resetViewAfterLayerChange)

            L.TileLayer.prototype.onRemove.call(this, map);
        }
    });

    /*
     * Factory method to create a new OSMap tilelayer.
     *
     * @public
     * @param {string} apiKey Your API key for OSMap.
     * @param {string} apiUrl The URL of your site as provided to OSMap.
     * @param {object} options Any options to pass to the tilelayer.
     * @return {L.TileLayer} TileLayer for Ordnance Survey OpenSpace service.
     */
    L.OSMap.tilelayer = function (apiKey, options) {
        return new L.OSMap.TileLayer(apiKey, options);
    };

    return L.OSMap;
}
